var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activateSpinner
        ? _c("spinner")
        : _c("div", [
            _vm.mode !== "edit"
              ? _c("div", [
                  _c(
                    "div",
                    [
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.security.certificat"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex align-items-center form-group",
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputValue:
                                        _vm.currentCertificate[0].name,
                                      inputLabel: _vm.$t(
                                        "common.security.name"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.name"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex align-items-center form-group",
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group mb-5",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputValue: _vm.getDate(
                                        _vm.currentCertificate[0].startDate
                                      ),
                                      inputLabel: _vm.$t(
                                        "common.security.startDate"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.startDate"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group mb-5",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputValue: _vm.getDate(
                                        _vm.currentCertificate[0].endDate
                                      ),
                                      inputLabel: _vm.$t(
                                        "common.security.endDate"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.endDate"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputValue:
                                        _vm.currentCertificate[0].deliveredBy,
                                      inputLabel: _vm.$t(
                                        "common.security.deliveredBy"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.deliveredBy"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputValue:
                                        _vm.currentCertificate[0].deliveredTo,
                                      inputLabel: _vm.$t(
                                        "common.security.deliveredTo"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.deliveredTo"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mx-auto mb-4" }),
                      _vm._v(" "),
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.security.private_key"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center form-group",
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group mb-5",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("div", [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("common.security.password")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "d-flex" }, [
                                      _c("input", {
                                        staticClass:
                                          "form-control inputAccordionForm inputLogin h-30px",
                                        attrs: {
                                          type: _vm.passwordFieldType,
                                          readonly: "",
                                          autocomplete: "off",
                                        },
                                        domProps: { value: _vm.getPassword() },
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "icon icon-password mt-2 pt-1",
                                        class: [
                                          _vm.isPasswordFieldHidden
                                            ? "fa-duotone fa-eye"
                                            : "fa-duotone fa-eye-slash",
                                        ],
                                        on: { click: _vm.toggleVisibility },
                                      }),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-col", {
                                staticClass: "form-group mb-5",
                                attrs: { sm: "6" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _c(
                  "div",
                  [
                    _c("certificate-form-edit", {
                      ref: "keystoreFormPem",
                      staticClass: "mt-3",
                      attrs: {
                        store: 1,
                        keystore: _vm.keystoreForEdit,
                        "technical-user": _vm.technicalUser,
                        "id-company": _vm.idCompany,
                        "name-company": _vm.nameCompany,
                        "id-user-api": _vm.idUserApi,
                        "id-rights-profile-api": _vm.idRightsProfileApi,
                        "id-certificate": _vm.idCertificate,
                        "id-private-key": _vm.idPrivateKey,
                      },
                    }),
                  ],
                  1
                ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }